import { render, staticRenderFns } from "./tabsLevel2.vue?vue&type=template&id=1395b765&scoped=true"
import script from "./tabsLevel2.vue?vue&type=script&lang=js"
export * from "./tabsLevel2.vue?vue&type=script&lang=js"
import style0 from "./tabsLevel2.vue?vue&type=style&index=0&id=1395b765&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1395b765",
  null
  
)

export default component.exports